import { HcFormField } from '@cosmos-web/hc-form-field'

import clsx from 'clsx'

import styles from './formField.module.css'
import type { FormFieldProps } from './types'

const FormField = ({
  inputName,
  label,
  validMsg,
  invalidMsg,
  supportMsg,
  children,
  isValid = true,
  ...rest
}: typeof HcFormField.defaultProps & FormFieldProps): JSX.Element => (
  <HcFormField {...rest} className={clsx(rest.className, styles.root)}>
    {label ? (
      <label htmlFor={inputName} slot='label'>
        {label}
      </label>
    ) : null}
    {children}
    {validMsg ? <div slot='valid-message'>{validMsg}</div> : null}
    {!isValid && invalidMsg ? <div slot='invalid-message'>{invalidMsg}</div> : null}
    {supportMsg ? <div slot='support-message'>{supportMsg}</div> : null}
  </HcFormField>
)

export default FormField
